module.exports = __webpack_public_path__ + "static/media/dd1c124b-61d0-4c5a-8639-075267a72521_1.b7eb306eb77049601605f432eb26cb11.ebb9eef0.jpeg";